import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const toggleSelector = '.js-toggle-component';
	const priceSelector = '.js-price-value';
	const descriptionSelector = '.js-price-description';
	const toggle = document.querySelectorAll(toggleSelector);

	if (!toggle.length) {
		return;
	}
	const { PriceToggle } = await import('./price-toggle');

	toggle.forEach((toggleElement) => {
		const toggle = new PriceToggle({
			toggleElement,
			priceSelector,
			descriptionSelector,
		});
		toggle.init();
	});
});
